<template>
<div class="chapter">
<div class="inner_page">
<div class="otherbooks" id="adc">
<p class="center">BOOKS BY ITALO CALVINO<br/><br/></p>
<div class="block">
<p class="center"><em>The Baron in the Trees</em></p>
<p class="center"><em>The Castle of Crossed Destinies</em></p>
<p class="center"><em>Collection of Sand</em></p>
<p class="center"><em>The Complete Cosmicomics</em></p>
<p class="center"><em>Difficult Loves</em></p>
<p class="center"><em>Fantastic Tales</em></p>
<p class="center"><em>Hermit in Paris</em></p>
<p class="center"><em>If on a winter’s night a traveler</em></p>
<p class="center"><em>Into the War</em></p>
<p class="center"><em>Invisible Cities</em></p>
<p class="center"><em>Italian Folktales</em></p>
<p class="center"><em>Marcovaldo</em></p>
<p class="center"><em>Mr. Palomar</em></p>
<p class="center"><em>The Nonexistent Knight and The Cloven Viscount</em></p>
<p class="center"><em>Numbers in the Dark</em></p>
<p class="center"><em>The Road to San Giovanni</em></p>
<p class="center"><em>Six Memos for the Next Millennium</em></p>
<p class="center"><em>Under the Jaguar Sun</em></p>
<p class="center"><em>The Uses of Literature</em></p>
<p class="center"><em>The Watcher and Other Stories</em></p>
<p class="center"><em>Why Read the Classics?</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Calv_9780307549310_epub_adc_r1.vue?2f5ce55c